<template>
  <div v-if="componentData.direction == 'Vertical'">
    <div>
      <div>
        <div>
          <div class="instruction_title text-left para-mrgn-20" v-translate:dynamic_string="{ key: `${translationKeyInitial}_formattedBody`, val: lang, html: question.formattedBody }" v-html="question.formattedBody" />
          <div @click.once="$emit('onClick', question)">
            <ds-slider
              ref="slider"
              :piecewise="true"
              width="2"
              direction="vertical"
              tooltip="none"
              class="vertical-vue-slider pl-0"
              :isCustomVerticalScale="true"
              :value="getValueForCustomScale()"
              :disabled="isFieldDisabled"
              @drag-end="onAnswerChange"
              @click-end="onAnswerChange"
              :min="componentData.minValue"
              :max="componentData.maxValue"
              :interval="componentData.partitions"
              :data="translatedScaleLabels"
              :piecewiseLabel="true"
              :dotSize="pointerValue"
              :piecewiseStyle="piecewiseStyle"
              :piecewiseActiveStyle="piecewiseActiveStyle"
              :labelActiveStyle="labelActiveStyle"
            ></ds-slider>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="componentData.direction == 'Horizontal'">
    <div class="instruction_title text-left para-mrgn-20" v-translate:dynamic_string="{ key: `${translationKeyInitial}_formattedBody`, val: lang, html: question.formattedBody }" v-html="question.formattedBody" />
    <div @click.once="$emit('onClick', question)">
      <ds-slider
        v-if="!componentData.verticalScale"
        ref="slider"
        :piecewise="true"
        width="1"
        direction="horizontal"
        tooltip="none"
        :value="getValueForCustomScale()"
        :disabled="isFieldDisabled"
        @drag-end="onAnswerChange"
        @click-end="onAnswerChange"
        :min="componentData.minValue"
        :max="componentData.maxValue"
        :interval="componentData.partitions"
        :data="translatedScaleLabels"
        :piecewiseLabel="true"
        :dotSize="pointerValue"
        :piecewiseStyle="piecewiseStyle"
        :piecewiseActiveStyle="piecewiseActiveStyle"
        :labelActiveStyle="labelActiveStyle"
      ></ds-slider>
    </div>
  </div>
</template>

<script>
import dsSlider from "@/lib/ds-slider-component";
import langTranslate from "./lang-translate";
import $ from "jquery";

export default {
  name: "custom-scale",
  mixins: [langTranslate],
  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      piecewiseStyle: {
        backgroundColor: "#ccc",
        visibility: "visible",
        width: "12px",
        height: "12px"
      },
      pointerValue: 0,
      piecewiseActiveStyle: {
        backgroundColor: "#ccc"
      },
      labelActiveStyle: {
        color: ""
      }
    };
  },
  mounted() {
    this.question.answer = this.getValueForCustomScale();
    if (this.question.answer) {
      this.pointerValue = 16;
      this.piecewiseActiveStyle.backgroundColor = "#3498db";
      this.labelActiveStyle.color = "#3498db";
    }
    if (this.componentData.direction == "Vertical") {
      $(".select-scroll").css({ overflow: "visible", height: "auto" });
    }
    this.$root.$on("questionSkipped", (notifyObj) => {
      if(!!notifyObj && notifyObj.identifier === this.question.identifier && notifyObj.skipped){
        this.clearAnswer();
      }
    });
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"],
  computed: {
    componentData() {
      return this.question.constraints;
    },
    translatedScaleLabels() {
      let translatedLabels = [];
      if (this.componentData && !!this.componentData.formattedLabels && this.componentData.formattedLabels.length) {
        this.componentData.formattedLabels.forEach((label, index) => {
          let translation = this.translateToActiveLang(`${this.translationKeyInitial}_formattedLabels_${index}_label`, label);
          translatedLabels.push(translation);
        });
      } else if (this.componentData && !!this.componentData.labels && this.componentData.labels.length) {
        this.componentData.labels.forEach((label, index) => {
          let translation = this.translateToActiveLang(`${this.translationKeyInitial}_labels_${index}_label`, label);
          translatedLabels.push(translation);
        });
      }

      return translatedLabels;
    }
  },
  components: {
    dsSlider
  },
  methods: {
    getValueForCustomScale() {
      if (this.question.skipped) {
        this.pointerValue = 0;
        this.piecewiseActiveStyle.backgroundColor = "#ccc";
        this.labelActiveStyle.color = "";
        return;
      }
      if (!this.question.hasOwnProperty("answer") || this.question.answer === false) {
        return undefined;
      }
      if (this.question.answer || this.question.answer === 0) {
        return this.question.answer;
      }
      return undefined;
    },
    clearAnswer() {
      this.question.answer = undefined;
      this.question.dataChecks = [];

      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.$emit("getQuestionScores");
      this.$emit("onClearAnswer", this.question);
    },
    onAnswerChange(event) {
      this.question.skipped = false;
      this.pointerValue = 16;
      this.piecewiseActiveStyle.backgroundColor = "#3498db";
      this.labelActiveStyle.color = "#3498db";
      this.$nextTick(() => {
        this.question.answer = event.val;
        this.$emit("onAnswerChange", this.question);
      });
    }
  }
};
</script>

<style scoped></style>
